export class TrialAutocomplete {
  constructor(
    public id: string,
    public label: string,
    public brandName: string = '',
    public diaryEnabled: boolean = false,
    public genericDiaryEnabled: boolean = false,
  ) { }
}
